<template>
    <div class="error-404-area">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="error-404-item">
                        <div class="error-404-img">
                            <div class="scene fill">
                                <div class="expand-width" data-depth="0.2">
                                    <img src="images/404/1-631x451.png" alt="404 Image">
                                </div>
                            </div>
                        </div>
                        <div class="error-404-content">
                            <h2 class="title">Sorry, this page is not found.</h2>
                            <p class="desc">There are many variations of passages of Lorem Ipsum available majority have
                                suffered alteration in some form.
                            </p>
                            <div class="btn-wrap">
                                <router-link to="/" class="btn btn-custom-size purple-color btn-lg blackcurrant-hover">
                                    <i class="icofont-long-arrow-left"></i>
                                    Back to home
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.btn.purple-color {
    background-color: #CE097C;
    color: white;
    border-color: #CE097C;
    font-family: 'Exo 2';
    font-style: normal;
    font-weight: 700;
    margin-bottom: 10px;
}
.btn.purple-color:hover {
    background-color: transparent;
    color: #CE097C;
    border-color: #CE097C;
}
</style>